export const MINUTES_WORDS = ['минута', 'минуты', 'минут'];
export const HOURS_WORDS = ['час', 'часа', 'часов'];
export const TIME_DATE_PARAMS = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
};
